import type { SkeletonProps as MuiSkeletonProps } from "@mui/material/Skeleton";
import { type FC } from "react";
import * as Styled from "./Skeleton.styled";

export enum SkeletonVariant {
    Text = "text",
    Rectangular = "rectangular",
    Rounded = "rounded",
    Circular = "circular",
}

export enum SkeletonPreset {
    TextFullWidth = "textFullWidth",
    TextShort = "textShort",
    SectionTitle = "sectionTitle",
    Block = "block",
    RoundedBlock = "roundedBlock",
    Circular = "circular",
}

type SkeletonPresetDefaults = Pick<MuiSkeletonProps, "variant" | "width" | "height">;

const presetDefaults: Record<SkeletonPreset, SkeletonPresetDefaults> = {
    [SkeletonPreset.TextFullWidth]: {
        variant: SkeletonVariant.Text,
        width: "100%",
    },
    [SkeletonPreset.TextShort]: {
        variant: SkeletonVariant.Text,
        width: "70%",
    },
    [SkeletonPreset.SectionTitle]: {
        variant: SkeletonVariant.Text,
        width: 250,
    },
    [SkeletonPreset.Block]: {
        variant: SkeletonVariant.Rectangular,
        width: "100%",
    },
    [SkeletonPreset.RoundedBlock]: {
        variant: SkeletonVariant.Rounded,
        width: "100%",
    },
    [SkeletonPreset.Circular]: {
        variant: SkeletonVariant.Circular,
    },
};

export type SkeletonProps = Omit<MuiSkeletonProps, "variant"> & {
    preset?: SkeletonPreset;
    variant?: SkeletonVariant;
};

export const Skeleton: FC<SkeletonProps> = ({ preset, variant, ...props }) => {
    const defaults = preset ? presetDefaults[preset] : undefined;

    return (
        <Styled.Root
            {...defaults}
            {...props}
            variant={variant ?? defaults?.variant ?? SkeletonVariant.Text}
        />
    );
};
